import { useExperience } from "../../../../../shared/context/ExperienceContext";
import { aboutPreviewContent } from "../../data/homeData.js";

import AboutImage from "./components/AboutImage/AboutImage.jsx";
import AboutContent from "./components/AboutContent/AboutContent.jsx";
import AboutStats from "./components/AboutStats/AboutStats.jsx";
import { BotanicalLeaf } from "./components/AboutDecorations/AboutDecorations.jsx";

import "./About.css";
import "./AboutResponsive.css";

export default function About() {
  const { mode } = useExperience();
  const about = aboutPreviewContent[mode] || aboutPreviewContent.all;

  return (
    <section className="about-preview">
      <BotanicalLeaf />

      <div className="about-preview__stage">
        <AboutImage image={about.image} imageAlt={about.imageAlt} />

        <AboutContent about={about} />

        <AboutStats stats={about.stats} />
      </div>
    </section>
  );
}